<template>
	<div class="footerBox">
		<div class="footer">
			<ul>
				<span>产品中心</span>
				<ul class="productC">
					<li  @click="$router.push({path:'/product',query:{id:item.id,name:item.name}})" v-for="(item,index) in product.slice(0,3)">{{item.name}}</li>
				</ul>
				<ul class="productR">
					<li    @click="$router.push({path:'/product',query:{id:item.id,name:item.name}})" v-for="(item,index) in product.slice(3,)">{{item.name}}</li>
				</ul>
			</ul>
			
			<ul>
				<span>服务支持</span>
				<li @click="$router.push({path:'/about'})">关于广源</li>
			</ul>
			<ul>
				<span>新闻中心</span>
				<li @click="$router.push({path:'/news'})">新闻中心</li>
			</ul>
			<ul>
				<span>合作案例</span>
				<li @click="$router.push({path:'/case'})">案例展示</li>
			</ul>
		</div>
		<div class="beian">{{beian}}</div>
	</div>
	
</template>

<script>
	export default{
		data(){
			return{
				product:[{
					id:1,
					name:'高压清洗机'
				},{
					id:3,
					name:'管道疏通机'
				},{
					id:12,
					name:'除锈清洗机'
				},{
					id:15,
					name:'墙面拉毛机'
				},{
					id:14,
					name:'高压冲毛机'
				},{
					id:2,
					name:'全自动清洗机'
				}]
			}
		}
	}
</script>

<style scoped="scoped">
	.footerBox{
		background-color: #153B67;
		color: #FFFFFF;
		height: 285px !important;
		text-align: center;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		padding: 0px!important;
	}
	.footer{
		width: 100%;
		height: 230px;
		padding: 30px 220px;
	}
	.footer ul{
		width: 25%;
		height: auto;
		float: left;
	}
	.footer ul .productC{
		width: 49%;
		text-align: left;
	}
	.footer ul .productR{
		width: 50%;
		text-align: left;
		box-sizing: border-box;
	}
	.footer ul:nth-child(1) span{
		text-align: left;
	}
	.footer ul span{
		display: block;
		font-size: 20px;
		line-height: 40px;
	
	}
	.footer ul  li{
		font-size: 16px;
		line-height: 40px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/footer.vue